export default __webpack_public_path__ + "static/media/dreamstime_xs_111954140.47d4ff1a.jpg";